var exports = {
  "aH": "x7f9a0e16--6fb918--header-container",
  "wx": "x7f9a0e16--6fb918--header",
  "Qs": "x7f9a0e16--6fb918--content",
  "ne": "x7f9a0e16--6fb918--controls",
  "DD": "x7f9a0e16--6fb918--title",
};

module.exports = exports;
